export class RatingModule {
    constructor(httpModule) {
        this.httpModule = httpModule;
    }
    async initiateAdd(rating) {
        const addReviewRes = await this.httpModule.fetch("/professors/ratings", {
            method: "POST",
            body: JSON.stringify(rating),
        });
        return addReviewRes.json();
    }
    async finishAdd(newReviewId) {
        const processingReviewRes = await this.httpModule.fetch(`/ratings/${newReviewId}`);
        return processingReviewRes.json();
    }
    async add(rating) {
        const initialResponse = await this.initiateAdd(rating);
        if (!initialResponse.newReviewId) {
            throw new Error(initialResponse.statusMessage);
        }
        return this.finishAdd(initialResponse.newReviewId);
    }
    async report(report) {
        await this.httpModule.fetch("/rating/report", {
            method: "POST",
            body: JSON.stringify(report),
        });
    }
}
//# sourceMappingURL=Rating.module.js.map